import { render, staticRenderFns } from "./FileStoreDialogManageFile.vue?vue&type=template&id=64b15de2&lang=pug&"
import script from "./FileStoreDialogManageFile.vue?vue&type=script&lang=js&"
export * from "./FileStoreDialogManageFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports